module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_3016.f6174a92.png";